import * as React from 'react';
import { Provider } from 'react-redux';
import {
  i18nReducer,
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n';

import { EmailTemplates } from './email-templates';
import { createStore } from '@common/utils/redux';
import { emailTemplatesEN } from './translations/en';
import { emailTemplatesES } from './translations/es';
import { emailTemplatesJA } from './translations/ja';
import { combineReducers } from 'redux';
import { mountReactNode } from '@common/utils/react';

export const initEmailTemplates = function (componentId: string, locale: string) {
  try {
    const store = createStore(combineReducers({ i18n: i18nReducer }));
  
    syncTranslationWithStore(store);
  
    const translation = {
      en: emailTemplatesEN,
      ja: emailTemplatesES,
      es: emailTemplatesJA,
    };
  
    if (!translation[locale as keyof typeof translation]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
    
    mountReactNode(
      <Provider store={store}>
        <EmailTemplates /> 
      </Provider>,
      document.getElementById(componentId)!
    );
  } catch (err) {
    console.error(err);
  }
};
